import type { JackpotProduct } from '../@types/api';
import type { JackpotFormData } from '../schema';

type JackpotCreateFormData = Omit<JackpotFormData, 'winningTickets'> & {
  winningTickets?: JackpotFormData['winningTickets'];
};

export const buildJackpotCreatePayload = (data: JackpotCreateFormData, product: JackpotProduct) => {
  const stakeRanges = data.payInAmountRanges.map((range) => ({
    from: Number(range.from),
    to: range.to ? Number(range.to) : null,
    contribution: Number(range.contribution),
  }));

  if (product === 'casino') {
    return {
      product,
      type: 'progressive' as const,
      name: data.name,
      isActive: data.isActive,
      winningLow: data.winningLow,
      winningHigh: data.winningHigh,
      description: data.description,
      icon: data.icon,
      stakeRanges,
      winningTickets: data.winningTickets,
    };
  }

  return {
    ...data,
    product,
    stakeRanges,
  };
};
